<template>
    <div>
        <MPanel
            v-if="config.table.columns.length"
            ref="tablePage"
            :config="config"
            :totalData="totalData"
            :pageTotal="pageTotal"
            :loading="loading"
            :pageID="pageID"
            :initSearchInfo="initSearchInfo"
            @searchChange="searchChange"
            @pageChange="pageChange"
            @sizeChange="sizeChange"
        ></MPanel>
    </div>
</template>
<script>
import dayjs from 'dayjs';
import MPanel from '../../../components/Panel.vue';
import { getAssessmentPage } from '../../../api/supMonthPerformance.js';
import config from './config.js';

export default {
    components: { MPanel },
    props: {
        isCurrentPanel: {
            type: Boolean,
            default() {
                return false;
            }
        },
        businessType: {
            type: String,
            default() {
                return '';
            }
        }
    },
    data() {
        return {
            config: JSON.parse(JSON.stringify(config)),
            totalData: [],
            pageTotal: 0,
            loading: false,
            pageID: 'achievements_monthly_assess_score_' + this.businessType,
            pageNo: 1,
            pageSize: 10,
            searchTerm: {},
            initSearchInfo: {
                assessmentMonth: dayjs().subtract(1, 'month').format('YYYY-MM')
            }
        };
    },
    methods: {
        searchChange(data) {
            this.pageNo = 1;
            this.searchTerm = data;
            this.loadData();
        },
        pageChange(data) {
            this.pageNo = data;
            this.loadData();
        },
        sizeChange(data) {
            this.pageSize = data;
            this.loadData();
        },
        loadData() {
            const params = {
                ...this.getParams(),
                pageNo: this.pageNo,
                pageSize: this.pageSize
            };
            this.loading = true;
            getAssessmentPage(params).then(res => {
                if (res && +res.code === 0) {
                    const columns = res.data.headerList.map(item => {
                        let col = { label: item.columnName, prop: item.columnCode, width: '150px' };
                        if (item.columnCode === 'transType') { // 采购渠道 处理
                            col = { ...col, type: 'select', options: [], optionNum: 'SRM_SHIPPER_TYPE' };
                        }
                        if (item.columnCode === 'noticeUrl') { // 发文链接 处理
                            col = { ...col, type: 'link', width: '400px' };
                        }
                        return col;
                    });
                    if (!this.config.table.columns.length) {
                        this.config.table.columns = columns;
                    }
                    this.$nextTick(() => {
                        this.totalData = res.data.tableDataList.list;
                        this.pageTotal = res.data.tableDataList.totalCount;
                    });
                }
            }).finally(() => {
                this.loading = false;
            });
        },
        getParams() {
            const params = { ...this.initSearchInfo, ...this.searchTerm, businessType: this.businessType, sysCode: 'LSP' };
            params.assessmentMonth = params.assessmentMonth ? dayjs(params.assessmentMonth).format('YYYY-MM') : '';
            return params;
        }
    },
    mounted() { },
    watch: {
        isCurrentPanel: {
            handler(val) {
                if (val) {
                    this.loadData();
                }
            },
            immediate: true
        }
    }
};
</script>
